'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cardNumber = require('./card-number');

var _cardNumber2 = _interopRequireDefault(_cardNumber);

var _cardExpiration = require('./card-expiration');

var _cardExpiration2 = _interopRequireDefault(_cardExpiration);

var _cardSecurityCode = require('./card-security-code');

var _cardSecurityCode2 = _interopRequireDefault(_cardSecurityCode);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _mixin = require('../../helpers/util/mixin');

var _mixin2 = _interopRequireDefault(_mixin);

var _addClass = require('../../helpers/dom/add-class');

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = require('../../helpers/dom/remove-class');

var _removeClass2 = _interopRequireDefault(_removeClass);

var _makeElement = require('../../helpers/dom/make-element');

var _makeElement2 = _interopRequireDefault(_makeElement);

var _messaging = require('../../mixins/messaging');

var _messaging2 = _interopRequireDefault(_messaging);

var _validation = require('../../mixins/validation');

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * # Unified Credit Card Input
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * An input container for credit card details.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new Spark.Payments.UnifiedCreditCard(el, {...});
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/payments/unified-credit-card.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var onValidEvent = document.createEvent('Event');
var onInvalidEvent = document.createEvent('Event');

onValidEvent.initEvent('valid', true, true);
onInvalidEvent.initEvent('invalid', true, true);

var UnifiedCreditCard = function (_BaseComponent) {
  _inherits(UnifiedCreditCard, _BaseComponent);

  /**
   * UnifiedCreditCard constructor.
   * @param {Element} el
   * @param {Object} params
   */
  function UnifiedCreditCard(el) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UnifiedCreditCard);

    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params));

    _this._bindEventListenerCallbacks();
    _this._addEventListeners();
    return _this;
  }

  /**
   * Sets up references
   * @param {Element} el base DOM element
   * @param {Object} params
   */


  UnifiedCreditCard.prototype._cacheElements = function _cacheElements(el, params) {
    var _this2 = this;

    this.el = el;

    this.number = new _cardNumber2.default(this.el.querySelector('.spark-payment--card-number'), {
      unified: this,
      cardTypes: params.cardTypes,
      onInput: function onInput() {
        if (_this2.number.inputEl.hasAttribute('data-novalidate')) {
          _this2.number.inputEl.removeAttribute('data-novalidate');
        }
        _this2._onInput();
      },
      onBlur: this._onBlur.bind(this),
      onFocus: function onFocus() {
        if (_this2.number.value && !_this2.number.inputEl.hasAttribute('data-novalidate')) {
          _this2.number.inputEl.attributes.setNamedItem(document.createAttribute('data-novalidate'));
        }
        _this2._onFocus();
      },
      onCardType: this._onCardType.bind(this),
      onInvalid: function onInvalid() {
        onInvalidEvent.input = _this2.number;
        _this2.el.dispatchEvent(onInvalidEvent);
      },
      onValid: function onValid() {
        _this2.expiration.focus();
      }
    });
    this.expiration = new _cardExpiration2.default(this.el.querySelector('.spark-payment--expiration'), {
      unified: this,
      onInput: function onInput() {
        if (_this2.expiration.inputEl.hasAttribute('data-novalidate')) {
          _this2.expiration.inputEl.removeAttribute('data-novalidate');
        }
        _this2._onInput();
      },
      onBlur: this._onBlur.bind(this),
      onFocus: function onFocus() {
        if (_this2.expiration.value && !_this2.expiration.inputEl.hasAttribute('data-novalidate')) {
          _this2.expiration.inputEl.attributes.setNamedItem(document.createAttribute('data-novalidate'));
        }
        _this2._onFocus();
      },
      onInvalid: function onInvalid() {
        onInvalidEvent.input = _this2.expiration;
        _this2.el.dispatchEvent(onInvalidEvent);
      },
      onValid: function onValid() {
        _this2.securityCode.focus();
      }
    });
    this.securityCode = new _cardSecurityCode2.default(this.el.querySelector('.spark-payment--card-security-code'), {
      unified: this,
      onInput: this._onInput.bind(this),
      onBlur: this._onBlur.bind(this),
      onFocus: this._onFocus.bind(this),
      info: params.info,
      onInvalid: function onInvalid() {
        onInvalidEvent.input = _this2.securityCode;
        _this2.el.dispatchEvent(onInvalidEvent);
      }
    });
    this.components = [this.number, this.expiration, this.securityCode];

    this.messageEl = this.el.querySelector('.spark-input__message') || (0, _makeElement2.default)('<span class="spark-input__message"></span>');
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   */


  UnifiedCreditCard.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {
    this._onInvalidBound = this._onInvalid.bind(this);
    this._onValidBound = this._onValid.bind(this);
  };

  /**
   * Add event listeners for DOM events.
   */


  UnifiedCreditCard.prototype._addEventListeners = function _addEventListeners() {
    this.el.addEventListener('invalid', this._onInvalidBound, false);
    this.el.addEventListener('valid', this._onValidBound, false);
  };

  /**
   * Remove event listeners for DOM events..
   */


  UnifiedCreditCard.prototype._removeEventListeners = function _removeEventListeners() {
    this.el.removeEventListener('invalid', this._onInvalidBound, false);
    this.el.removeEventListener('valid', this._onValidBound, false);
    this.components.every(function (component) {
      return component._removeEventListeners();
    });
  };

  /**
   * Called when the Card Number field recognizes a new type of card,
   * and used to update the max length of the CVV field
   */


  UnifiedCreditCard.prototype._onCardType = function _onCardType() {
    var type = this.number._cardTypes[this.number.type];
    this.securityCode.maxLength = type.cvv;
    this.onCardType.call(this);
  };

  /**
   * onInput callback for running validation
   */


  UnifiedCreditCard.prototype._onInput = function _onInput() {
    if (this.valid) {
      this.el.dispatchEvent(onValidEvent);
    }
    this.onInput.call(this);
  };

  /**
   * onBlur callback, for firing provided callback
   */


  UnifiedCreditCard.prototype._onBlur = function _onBlur() {
    this.hide();
    this.onBlur.call(this);
  };

  /**
   * onFocus callback, for firing provided callback
   */


  UnifiedCreditCard.prototype._onFocus = function _onFocus() {
    this.show();
    this.onFocus.call(this);
  };

  /**
   * onInvalid method for firing provided callback
   * @param {Event} e
   */


  UnifiedCreditCard.prototype._onInvalid = function _onInvalid(e) {
    this.onInvalid.call(this, e);
  };

  /**
   * onValid method for firing provided callback
   */


  UnifiedCreditCard.prototype._onValid = function _onValid() {
    this.onValid.call(this);
  };

  /**
   * Getter for Valid state, returns true if component value is valid, false if not
   * @return {Boolean}
   */


  /**
   * Default validate function. This can be overridden by passing a
   * custom validate method as a parameter.
   */
  UnifiedCreditCard.prototype.validate = function validate() {
    this.onValidate(this.valid, this.value, this);
    return this;
  };

  /**
   * Show the input by adding the active state and setting character counts (if necessary).
   */


  UnifiedCreditCard.prototype.show = function show() {
    (0, _addClass2.default)(this.el, 'active');
    return this;
  };

  /**
   * Hide the input by removing the active state.
   */


  UnifiedCreditCard.prototype.hide = function hide() {
    (0, _removeClass2.default)(this.el, 'active');
    return this;
  };

  /**
   * Returns the current values
   * @return {Object}
   */


  UnifiedCreditCard.prototype.getValue = function getValue() {
    return this.value;
  };

  /**
   * Set the value of the input.
   * @param {Object} values
   */


  UnifiedCreditCard.prototype.setValue = function setValue() {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.value = values;
    return this;
  };

  /**
   * Clear the value of the input.
   */


  UnifiedCreditCard.prototype.clearValue = function clearValue() {
    this.components.every(function (component) {
      return component.value = '';
    });
    return this;
  };

  /**
   * Disable the input.
   */


  UnifiedCreditCard.prototype.disable = function disable() {
    this.components.every(function (component) {
      return component.disable();
    });
    return this;
  };

  /**
   * Enable the input.
   */


  UnifiedCreditCard.prototype.enable = function enable() {
    this.components.every(function (component) {
      return component.enable();
    });
    return this;
  };

  /**
   * Remove component from DOM.
   * @param {Boolean} leaveElement
   */


  UnifiedCreditCard.prototype.remove = function remove(leaveElement) {
    this.components.every(function (component) {
      return component.remove(leaveElement);
    });
    return _BaseComponent.prototype.remove.call(this, leaveElement);
  };

  /**
   * Update the element in use and the position.
   * @param {Element} el
   * @param {Object} params
   */


  UnifiedCreditCard.prototype.update = function update(el) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this._removeEventListeners();
    this.components.every(function (component) {
      return component.remove(true);
    });
    this._cacheElements.call(this, el || this.el, params);
    this._addEventListeners();
    return this;
  };

  _createClass(UnifiedCreditCard, [{
    key: 'valid',
    get: function get() {
      return this.components.every(function (component) {
        return component.valid;
      });
    }

    /**
     * Getter for Primary Component Values
     * @return {Object}
     */

  }, {
    key: 'value',
    get: function get() {
      return {
        number: this.number.value,
        expiration: this.expiration.value,
        securityCode: this.securityCode.value
      };
    }

    /**
     * Setter for Primary Component Values
     * @param {Object} values
     */
    ,
    set: function set() {
      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.number.value = values.number || this.number.value;
      this.expiration.value = values.expiration || this.expiration.value;
      this.securityCode.value = values.securityCode || this.securityCode.value;

      if (this.components.some(function (component) {
        return !!component.value;
      })) {
        this.show();
      } else {
        this.hide();
      }
    }
  }]);

  return UnifiedCreditCard;
}(_base2.default);

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */


UnifiedCreditCard.prototype.defaults = {
  el: null,
  number: {},
  expiration: {},
  securityCode: {},
  onCardType: function onCardType() {},
  onInput: function onInput() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onValid: function onValid() {},
  onInvalid: function onInvalid() {},
  onValidate: function onValidate() {},
  validate: function validate() {}
};

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
 */
UnifiedCreditCard.prototype._whitelistedParams = ['onCardType', 'onInput', 'onBlur', 'onFocus', 'onValid', 'onInvalid', 'onValidate', 'validate'];

(0, _mixin2.default)(UnifiedCreditCard.prototype, _messaging2.default, _validation2.default);

exports.default = UnifiedCreditCard;
module.exports = exports['default'];
//# sourceMappingURL=unified-credit-card.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/js/dist/components/payments/unified-credit-card.js
// module id = 853
// module chunks = 0